import { useContext } from 'react';
import PageContext from '../../common/context/page';

export default function usePageContext() {
  return useContext(PageContext);
}
